import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export default class StatusButton extends Component {
  render() {
    const {
      url,
      onClick,
      style,
    } = this.props;

    return (
      <Image
        style={style}
        url={url}
        onClick={onClick}
      />
    );
  }
}

StatusButton.propTypes = {
  url: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  style: PropTypes.objectOf({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }),
};

StatusButton.defaultProps = {
  style: {},
};

const Image = styled.div`
  background-image: url(${props => props.url});
  background-size: cover;
  width: 20px;
  height: 20px;
  cursor: pointer;
`;




// WEBPACK FOOTER //
// ./client/Dashboard/components/StatusButton.js